
import { ActionTypes } from './action';
import { ISizeSpecsRes } from "./types";


const initialState: ISizeSpecsRes = {
  items: [],
  totalCount: 0,
  optionList: [],
 
};

const sizeSpecsReducers = (state: ISizeSpecsRes = initialState, action): ISizeSpecsRes => {
  switch (action?.type) {
    case ActionTypes.SIZE_SPECS_LIST: {
      const optionList = action?.payload?.items?.map((item: any, index: any) => {
        return {
          ...item,
          value: item.id,
          label: item.name,
        }
      })
      return {
        ...state,
        ...action?.payload,
        optionList: optionList
      };
    }
    case ActionTypes.ADD_SIZE_SPECS: {
      const items = [];
      items.push(action?.payload);
      state?.items?.map((item) =>
        (items.push(item))
      )
      const totalCount = state?.totalCount + 1;
      return {
        ...state,
        items: items,
        totalCount: totalCount,
      };
    }
    case ActionTypes.UPDATE_SIZE_SPECS: {
      const updatedList = state?.items.map(item =>
        item.id === action?.payload.id ? action?.payload : item
      );
      return {
        ...state,
        items: updatedList,
      };
    }
    case ActionTypes.DELETE_SIZE_SPECS: {
      const updatedList = state.items.filter(item => item.id !== action.payload.id);
      const totalCount = state?.totalCount - 1;
      return {
        ...state,
        items: updatedList,
        totalCount: totalCount
      };
    }
    case ActionTypes.ADMIN_LOGOUT: {
      return initialState
    }
    default:
      return state;
  }
};

export default sizeSpecsReducers;
